
import { useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import Footer from '../../home/components/Footer';

export default function BeratungPage() {
  const navigate = useNavigate();
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    window.scrollTo(0, 0);
    const handleScroll = () => setScrolled(window.scrollY > 50);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const handleRequestClick = () => {
    navigate('/');
    setTimeout(() => {
      const contactSection = document.getElementById('kontakt');
      if (contactSection) {
        contactSection.scrollIntoView({ behavior: 'smooth' });
        window.dispatchEvent(new CustomEvent('preselect-service', { detail: 'Beratung' }));
      }
    }, 100);
  };

  return (
    <div className="min-h-screen bg-white">
      <nav className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${scrolled ? 'bg-white shadow-md' : 'bg-transparent'}`}>
        <div className="max-w-7xl mx-auto px-4 sm:px-6 py-4 flex items-center justify-between">
          <Link to="/">
            <img src="https://public.readdy.ai/ai/img_res/cd59830a-a811-4b8c-95fb-12d94d035ec5.png" alt="Elektro Tomasevic KG" className="h-10 sm:h-12 w-auto" />
          </Link>
          <a href="tel:+436991223301" className="bg-[#F4B942] text-[#1A2B4A] px-4 sm:px-6 py-2.5 sm:py-3 rounded-full font-semibold hover:bg-[#e5a832] transition-colors cursor-pointer whitespace-nowrap text-sm sm:text-base">
            <i className="ri-phone-fill mr-1 sm:mr-2"></i>
            <span className="hidden sm:inline">+43 699 122 333 01</span>
            <span className="sm:hidden">Anrufen</span>
          </a>
        </div>
      </nav>

      <main className="pt-24 sm:pt-32 pb-16 sm:pb-24">
        <div className="max-w-4xl mx-auto px-4 sm:px-6">
          <Link
            to="/"
            onClick={(e) => {
              e.preventDefault();
              navigate('/');
              setTimeout(() => {
                const el = document.getElementById('leistungen');
                if (el) el.scrollIntoView({ behavior: 'smooth' });
              }, 100);
            }}
            className="inline-flex items-center text-[#1A2B4A] hover:text-[#F4B942] transition-colors mb-6 sm:mb-8 cursor-pointer text-sm sm:text-base"
          >
            <i className="ri-arrow-left-line mr-2"></i>
            Zurück zu allen Leistungen
          </Link>

          <div className="bg-gradient-to-br from-amber-50 to-yellow-50 rounded-3xl p-8 sm:p-12 mb-10 sm:mb-12">
            <div className="w-16 h-16 sm:w-20 sm:h-20 flex items-center justify-center bg-[#F4B942] rounded-2xl mb-5 sm:mb-6">
              <i className="ri-lightbulb-flash-fill text-[#1A2B4A] text-3xl sm:text-4xl"></i>
            </div>
            <h1 className="text-3xl sm:text-5xl font-bold text-[#1A2B4A] mb-3 sm:mb-4">Elektro-Beratung &amp; Planung</h1>
            <p className="text-base sm:text-xl text-gray-600">
              Kompetente Beratung für Ihre Elektroprojekte – von der ersten Idee bis zur Umsetzung
            </p>
          </div>

          <div className="mb-10 sm:mb-12 space-y-4 sm:space-y-6">
            <p className="text-gray-700 leading-relaxed text-base sm:text-lg">
              Jedes Elektroprojekt beginnt mit einer guten Planung. Ob Neubau, Sanierung, Modernisierung oder
              Erweiterung – wir beraten Sie umfassend und entwickeln gemeinsam mit Ihnen die optimale Lösung für
              Ihre individuellen Anforderungen.
            </p>
            <p className="text-gray-700 leading-relaxed text-base sm:text-lg">
              Bei einem kostenlosen Erstgespräch nehmen wir uns Zeit, Ihre Wünsche und Vorstellungen zu verstehen.
              Wir analysieren die örtlichen Gegebenheiten, prüfen technische Möglichkeiten und erstellen ein
              maßgeschneidertes Konzept.
            </p>

            <div className="bg-[#1A2B4A] rounded-2xl p-6 sm:p-8 text-white">
              <h3 className="text-xl sm:text-2xl font-bold mb-4 flex items-center">
                <i className="ri-question-answer-fill text-[#F4B942] mr-3 text-2xl sm:text-3xl"></i>
                Unsere Beratungsthemen
              </h3>
              <ul className="space-y-3 text-white/90">
                {[
                  'Elektroplanung für Neubauten und Sanierungen',
                  'Photovoltaik-Anlagen: Dimensionierung, Wirtschaftlichkeit, Förderungen',
                  'Smart-Home-Systeme und Gebäudeautomation',
                  'Sicherheitstechnik: Alarmanlagen, Videoüberwachung, Zutrittskontrolle',
                  'Beleuchtungskonzepte für Wohn- und Geschäftsräume',
                  'E-Mobilität: Wallbox-Installation und Ladeinfrastruktur',
                  'Energieeffizienz und Kosteneinsparung',
                ].map((item, i) => (
                  <li key={i} className="flex items-start">
                    <i className="ri-arrow-right-s-fill text-[#F4B942] mr-3 mt-1 shrink-0"></i>
                    <span className="text-sm sm:text-base">{item}</span>
                  </li>
                ))}
              </ul>
            </div>

            <p className="text-gray-700 leading-relaxed text-base sm:text-lg">
              Unsere Beratung ist herstellerunabhängig und orientiert sich ausschließlich an Ihren Bedürfnissen.
              Wir erklären Ihnen alle technischen Zusammenhänge verständlich und transparent.
            </p>

            <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 sm:gap-6">
              {[
                { icon: 'ri-user-star-fill', title: 'Persönlich', desc: 'Individuelle Beratung vor Ort oder in unserem Büro' },
                { icon: 'ri-shield-check-fill', title: 'Kompetent', desc: 'Über 10 Jahre Erfahrung in allen Bereichen der Elektrotechnik' },
                { icon: 'ri-hand-heart-fill', title: 'Unverbindlich', desc: 'Kostenlose Erstberatung ohne Verpflichtung' },
              ].map((card, i) => (
                <div key={i} className="bg-amber-50 rounded-xl p-5 sm:p-6 text-center">
                  <div className="w-14 h-14 sm:w-16 sm:h-16 flex items-center justify-center bg-[#F4B942] rounded-full mx-auto mb-3 sm:mb-4">
                    <i className={`${card.icon} text-[#1A2B4A] text-xl sm:text-2xl`}></i>
                  </div>
                  <h4 className="text-base sm:text-lg font-bold text-[#1A2B4A] mb-2">{card.title}</h4>
                  <p className="text-gray-600 text-sm">{card.desc}</p>
                </div>
              ))}
            </div>

            <div className="bg-gradient-to-r from-[#F4B942]/10 to-[#F4B942]/5 border-l-4 border-[#F4B942] p-5 sm:p-6 rounded-r-xl">
              <p className="text-[#1A2B4A] font-semibold flex items-start gap-3 text-sm sm:text-base">
                <i className="ri-information-fill text-[#F4B942] text-xl sm:text-2xl shrink-0 mt-0.5"></i>
                Tipp: Vereinbaren Sie einen Beratungstermin, bevor Sie mit Ihrem Projekt starten. Eine gute
                Planung spart Zeit, Geld und Nerven – und sorgt für ein optimales Ergebnis.
              </p>
            </div>
          </div>

          <div className="bg-[#F8F9FB] rounded-2xl p-6 sm:p-8 text-center">
            <h3 className="text-xl sm:text-2xl font-bold text-[#1A2B4A] mb-3 sm:mb-4">Kostenlose Erstberatung vereinbaren</h3>
            <p className="text-gray-600 mb-5 sm:mb-6 text-sm sm:text-base">
              Lassen Sie uns gemeinsam Ihr Projekt besprechen – unverbindlich und kompetent.
            </p>
            <div className="flex flex-col sm:flex-row gap-3 sm:gap-4 justify-center">
              <a
                href="tel:+436991223301"
                className="inline-flex items-center justify-center bg-[#1A2B4A] text-white px-6 sm:px-8 py-4 rounded-xl font-bold text-base hover:bg-[#2A3B5A] transition-colors cursor-pointer whitespace-nowrap"
              >
                <i className="ri-phone-fill mr-2"></i>
                Jetzt anrufen
              </a>
              <button
                onClick={handleRequestClick}
                className="inline-flex items-center justify-center bg-[#F4B942] text-[#1A2B4A] px-6 sm:px-8 py-4 rounded-xl font-bold text-base hover:bg-[#e5a832] transition-colors cursor-pointer whitespace-nowrap"
              >
                <i className="ri-mail-send-fill mr-2"></i>
                Termin anfragen
              </button>
            </div>
          </div>
        </div>
      </main>

      <Footer />
    </div>
  );
}
